import dayjs from "dayjs";
import { useMemo } from "react";
import { ESTIMATION_TIME, PARCEL_STATUSES } from "../constants";
import { isParcelTrackingCode } from "../utils";

export const useTrackingData = (responseData, trackingNumber) => {
  return useMemo(() => {
    if (!responseData) return null;

    const originCountry = responseData.dispatchCountry?.includes("CN")
      ? "Китай"
      : responseData.dispatchCountry;
    const destinationCountry = responseData.recipientCountry?.includes("Russia")
      ? "Россия"
      : responseData.recipientCountry;

    // Check if it is a shipment (not a parcel)
    const isShipment = !isParcelTrackingCode(trackingNumber);

    // If it is a shipment, we reverse the checkpoints so the newest is first
    const sourceCheckpoints = isShipment
      ? [...responseData.checkpoints].reverse()
      : responseData.checkpoints;

    const checkpoints = sourceCheckpoints.map((checkpoint) => ({
      ...checkpoint,
      date: dayjs(checkpoint.date).format("DD.MM.YYYY HH:mm"),
    }));

    const isDelivered = checkpoints[0].statusCategoryId === 11;

    const deliveryDate = isDelivered ? responseData.checkpoints[0].date : null;

    const findFirstCalculable =
      responseData.checkpoints.find(
        (check) => check.statusName === PARCEL_STATUSES.READY_FOR_SENT
      )?.date || dayjs();

    const daysInTransit = isDelivered
      ? dayjs(deliveryDate).diff(dayjs(findFirstCalculable), "days")
      : dayjs().diff(dayjs(findFirstCalculable), "days");

    const estimatedArrivalInDays = responseData.estimatedArrivalDate
      ? dayjs(responseData.estimatedArrivalDate).diff(
        dayjs(findFirstCalculable),
        "days"
      )
      : ESTIMATION_TIME;

    const progress = isDelivered
      ? 100
      : Math.min((daysInTransit * 100) / estimatedArrivalInDays, 100);

    const isDelay = (daysInTransit * 100) / estimatedArrivalInDays > 100;

    return {
      ...responseData,
      originCountry,
      destinationCountry,
      daysInTransit,
      progress,
      checkpoints,
      deliveredStr: isDelivered ? "Доставлен" : '',
      isDelivered,
      isDelay,
    };
  }, [responseData, trackingNumber]);
};
